// © Microsoft Corporation. All rights reserved.

/**
 * Enum for different page types
 * @enum
 */
export enum PageType {
    Article = "article",
    ArticleFullScreen = "articlefullscreen",
    DHP = "dhp",
    Gallery = "gallery",
    GalleryFullScreen = "galleryfullscreen",
    Launcher = "launcher",
    MMX = "mmx",
    NewsAndInterests = "newsandinterestshp",
    Newsbar = "newsbar",
    NTP = "ntp",
    Story = "story",
    Shopping = "shopping",
    ShoppingDealsStoreCategory = "shopping::deals::storecategory",
    Video = "video",
    Windows = "windowshp",
    WindowsShell = "shellhp"
}

/** The AudienceMode enum */
export enum AudienceModeType {
    Adult = "adult",
    Enterprise = "enterprise",
    Kids = "kids"
}